var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotaflex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 790,
    viewBox: "0 0 854 790",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.56995 480.71H836.55V600.88L765.18 553.3L661.48 597.83L556.56 553.3L465.67 638.09L367.46 666.15L324.15 630.16L289.99 578.31L257.66 609.42L185.68 549.03L135.66 556.35L79.54 508.16L6.94995 489.86L7.55995 480.71H7.56995Z",
    fill: "#384252",
    stroke: "#EEEEEE",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M693.35 493.02H642.93V627.74H693.35V493.02Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M643.32 474.82H693.08L692.98 493.54L643.27 503.14L643.32 474.83V474.82Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M651.62 501.57V519.9L684.89 512.73V495.05L651.62 501.57Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M661.87 517.74V568.1L668.18 558.34L674.06 562.55V515.16L661.87 517.75V517.74Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M643.24 627.8L654.12 628.22V689.1L662.49 692.66L663.33 691.2L673.37 691.62L674.42 692.46L681.11 689.53L681.74 688.27L682.35 627.99H693V769.26H643.3L643.25 627.81L643.24 627.8Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M643.11 628.18H651.65L651.72 689.53L668.1 693.86L684.89 688.16V628.14H693.03V769.37H643.18L643.11 628.18Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M643.16 503.13V769.37H693.03V493.48",
    fill: "#131F2E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M643.16 503.13V769.37H693.03V493.48",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M651.68 519.79V736.53V519.79Z",
    fill: "#131F2E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M651.68 519.79V736.53",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M684.84 512.73V736.27V512.73Z",
    fill: "#131F2E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M684.84 512.73V736.27",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M662.24 736.43V727.91H654.04V585.84H651.65",
    fill: "#131F2E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M662.24 736.43V727.91H654.04V585.84H651.65",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M684.83 585.87H682.32V727.91H674.15V736.16",
    fill: "#131F2E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M684.83 585.87H682.32V727.91H674.15V736.16",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M668.34 575.26L672.96 579.88V628.1H674.51V640.23H661.83V628.03H663.46V581.77L668.34 575.26Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M662.42 642.23L655.17 648.66V689.49L662.09 692.45",
    fill: "#131F2E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M662.42 642.23L655.17 648.66V689.49L662.09 692.45",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M674.1 642.23L681.35 648.66V689.49L674.43 692.45",
    fill: "#131F2E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M674.1 642.23L681.35 648.66V689.49L674.43 692.45",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M662.46 672.19L655.14 674.59L662.46 672.19Z",
    fill: "#131F2E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M662.46 672.19L655.14 674.59",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M674.07 672.19L681.39 674.59L674.07 672.19Z",
    fill: "#131F2E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M674.07 672.19L681.39 674.59",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M654.1 716.08H662.49H654.1Z",
    fill: "#131F2E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M654.1 716.08H662.49",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M673.74 716.08H682.13H673.74Z",
    fill: "#131F2E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M673.74 716.08H682.13",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M674.1 721.48C674.1 724.73 671.47 727.36 668.22 727.36C664.97 727.36 662.34 724.73 662.34 721.48C662.34 718.23 664.97 715.6 668.22 715.6C671.47 715.6 674.1 718.23 674.1 721.48Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M674.14 687.35C674.14 690.6 671.51 693.23 668.26 693.23C665.01 693.23 662.38 690.6 662.38 687.35C662.38 684.1 665.01 681.47 668.26 681.47C671.51 681.47 674.14 684.1 674.14 687.35Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M643.19 735.87L595.85 741.2L643.19 744.75V735.87Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M643.19 754.8L595.85 760.13L643.19 763.68V754.8Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M693.19 754.8L740.53 760.13L693.19 763.68V754.8Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M693.19 735.87L740.53 741.2L693.19 744.75V735.87Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M643.33 474.64H640.82V477.3H643.33V474.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M662.27 474.64H659.76V477.3H662.27V474.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M676.76 474.64H674.25V477.3H676.76V474.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M696.14 474.64H693.63V477.3H696.14V474.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M696.29 462.51H693.78V465.17H696.29V462.51Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M676.91 462.51H674.4V465.17H676.91V462.51Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M662.27 462.36H659.76V465.02H662.27V462.36Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M643.48 462.65H640.97V465.31H643.48V462.65Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M651.62 464.87V449.63H684.75V465.16L651.62 464.86V464.87Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M639.71 465.01L639.82 474.61H696.54V465.01H639.71Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M639.65 469.87L696.64 469.98L639.65 469.87Z",
    fill: "#131F2E"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M639.65 469.87L696.64 469.98",
    stroke: "#F7F9F9"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M712.95 433.17V429.67H717.19V433.17H712.95Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M685.86 432.04H695.38L696.74 434.45H709.29V433.19H721L721.47 435.23H734.7L730.99 442.55H721.58L720.27 444.01H709.86L708.87 442.75H696.32V446.1H685.96L685.86 432.03V432.04Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M649.32 449.73L685.94 449.78V428.33H649.4L649.32 449.73Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M658.08 428.26H655.57V430.92H658.08V428.26Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M654 419.89H651.49V422.55H654V419.89Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M686.01 419.73H683.5V422.39H686.01V419.73Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M680.73 428.1H678.22V430.76H680.73V428.1Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M648.05 422.16V428.59H688.37V422.16H648.05Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M648.16 425.25H688.33H648.16Z",
    fill: "#131F2E"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M648.16 425.25H688.33",
    stroke: "#F7F9F9"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M696.69 434.35C696.69 434.35 695.43 438.27 696.48 442.87L696.69 434.35Z",
    fill: "#131F2E"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M696.69 434.35C696.69 434.35 695.43 438.27 696.48 442.87",
    stroke: "#F7F9F9"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M709.19 434.4C709.19 434.4 708.35 437.64 709.19 442.92V434.4Z",
    fill: "#131F2E"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M709.19 434.4C709.19 434.4 708.35 437.64 709.19 442.92",
    stroke: "#F7F9F9"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M721.53 435.39C721.53 435.39 720.69 438.63 721.58 442.45L721.53 435.39Z",
    fill: "#131F2E"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M721.53 435.39C721.53 435.39 720.69 438.63 721.58 442.45",
    stroke: "#F7F9F9"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M720.54 424.77C720.54 427.8 718.09 430.27 715.06 430.27C712.03 430.27 709.56 427.82 709.56 424.79V424.77C709.56 421.74 712.01 419.27 715.04 419.27C718.07 419.27 720.54 421.72 720.54 424.75V424.77Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M710.34 427.26L711.75 426.66L710.34 427.26Z",
    fill: "#131F2E"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M710.34 427.26L711.75 426.66",
    stroke: "#F7F9F9"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M709.66 425.27L711.1 425.19L709.66 425.27Z",
    fill: "#131F2E"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M709.66 425.27L711.1 425.19",
    stroke: "#F7F9F9"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M709.95 423L711.23 423.44L709.95 423Z",
    fill: "#131F2E"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M709.95 423L711.23 423.44",
    stroke: "#F7F9F9"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M711.15 420.99L712.12 421.93L711.15 420.99Z",
    fill: "#131F2E"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M711.15 420.99L712.12 421.93",
    stroke: "#F7F9F9"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M715.01 425.73L711.45 421.53L712.57 420.62L715.93 424.87L715.01 425.73Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M712.88 419.71L713.43 420.97L712.88 419.71Z",
    fill: "#131F2E"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M712.88 419.71L713.43 420.97",
    stroke: "#F7F9F9"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M715.99 424.82C715.99 425.3 715.61 425.69 715.13 425.69C714.65 425.69 714.26 425.31 714.26 424.83C714.26 424.34 714.64 423.95 715.12 423.95C715.6 423.95 715.99 424.33 715.99 424.81V424.82Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M715.1 419.31L715.07 420.67L715.1 419.31Z",
    fill: "#131F2E"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M715.1 419.31L715.07 420.67",
    stroke: "#F7F9F9"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M719.87 427.26L718.46 426.66L719.87 427.26Z",
    fill: "#131F2E"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M719.87 427.26L718.46 426.66",
    stroke: "#F7F9F9"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M720.55 425.27L719.11 425.19L720.55 425.27Z",
    fill: "#131F2E"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M720.55 425.27L719.11 425.19",
    stroke: "#F7F9F9"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M720.27 423L718.99 423.44L720.27 423Z",
    fill: "#131F2E"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M720.27 423L718.99 423.44",
    stroke: "#F7F9F9"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M719.06 420.99L718.09 421.93L719.06 420.99Z",
    fill: "#131F2E"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M719.06 420.99L718.09 421.93",
    stroke: "#F7F9F9"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M717.34 419.71L716.79 420.97L717.34 419.71Z",
    fill: "#131F2E"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M717.34 419.71L716.79 420.97",
    stroke: "#F7F9F9"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M720.54 424.77C720.54 427.8 718.09 430.27 715.06 430.27C712.03 430.27 709.56 427.82 709.56 424.79V424.77C709.56 421.74 712.01 419.27 715.04 419.27C718.07 419.27 720.54 421.72 720.54 424.75V424.77Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M660.95 421.86V402.11H657.51V398.26H677.04V402.22H673.3V421.86H660.95Z",
    fill: "#F7F9F9",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M667.42 398.27V142.93V398.27Z",
    fill: "#F7F9F9"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M667.42 398.27V142.93",
    stroke: "#F7F9F9",
    strokeWidth: 3.52
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M599.85 157.26H638.67V148.85L650.1 142.38H677.92V132.89C655.07 106.65 628.35 105.1 599.42 105.07L599.85 157.26Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M639.01 157.45H599.53V244.79H639.01V157.45Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M626.27 174.49H613.11V188.51H626.27V174.49Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M612.68 185.05H626.05H612.68Z",
    fill: "#131F2E"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M612.68 185.05H626.05",
    stroke: "#F7F9F9"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M458.24 465.38L602.58 321.27L602.66 332.94L471.05 465.69L458.24 465.39V465.38Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M537.27 463.25V458.98H555.87V451.89H603.53V466.07H536.74L537.27 463.25Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M600.02 417.58H555.65C554.048 417.58 552.75 418.878 552.75 420.48V449.45C552.75 451.052 554.048 452.35 555.65 452.35H600.02C601.622 452.35 602.92 451.052 602.92 449.45V420.48C602.92 418.878 601.622 417.58 600.02 417.58Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M638.15 456.77H643.94L649.43 463.17L647.14 467.44L634.33 466.53L638.14 456.77H638.15Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M639 244.79H599.53V464.12H639V244.79Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M636.4 244.79H602.11V463.69H636.4V244.79Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M649.35 463.34H411.56V481.6H649.35V463.34Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M649.35 466.5H411.47V478.58H649.35V466.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M599.53 420.17H552.77V434.2H599.53V420.17Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.51,
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M599.6 437.25H552.77V449.75H599.6V437.25Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.43,
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M108.29 271.88H103.11V326.46H108.29V271.88Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5699 328.09H74.5599V331.79H95.5699V328.09Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8999 388.23C93.9699 395.03 102.55 394.81 104.92 388.38L106.03 384.09",
    fill: "#131F2E"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8999 388.23C93.9699 395.03 102.55 394.81 104.92 388.38L106.03 384.09",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M78.59 480.09H91.83L91.9 387.05L78.59 386.9V480.09Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M89.04 480.23L88.87 387.04H78.59V480.16L89.04 480.23Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.08
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4499 383.86H74.6699V387.26H95.4499V383.86Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M110.8 331.05H60.95V384.45H110.8V331.05Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M108.58 334.45H63.1699V381.05H108.58V334.45Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5899 372.82C75.5899 376.12 73.0399 378.79 69.8899 378.79C66.7399 378.79 64.1899 376.12 64.1899 372.82C64.1899 369.52 66.7399 366.85 69.8899 366.85C73.0399 366.85 75.5899 369.52 75.5899 372.82Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4299 372.85C87.4299 376.16 84.8799 378.85 81.7299 378.85C78.5799 378.85 76.0299 376.16 76.0299 372.85C76.0299 369.54 78.5799 366.85 81.7299 366.85C84.8799 366.85 87.4299 369.54 87.4299 372.85Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M99.26 372.8C99.26 376.09 96.71 378.75 93.56 378.75C90.41 378.75 87.86 376.08 87.86 372.8C87.86 369.52 90.41 366.85 93.56 366.85C96.71 366.85 99.26 369.52 99.26 372.8Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4 372.77C73.4 374.58 71.93 376.05 70.12 376.05C68.31 376.05 66.84 374.58 66.84 372.77C66.84 370.96 68.31 369.49 70.12 369.49C71.93 369.49 73.4 370.96 73.4 372.77Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.43,
    strokeMiterlimit: 5.71
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2299 372.77C85.2299 374.58 83.7599 376.05 81.9499 376.05C80.1399 376.05 78.6699 374.58 78.6699 372.77C78.6699 370.96 80.1399 369.49 81.9499 369.49C83.7599 369.49 85.2299 370.96 85.2299 372.77Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.43,
    strokeMiterlimit: 5.71
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M97.06 372.77C97.06 374.58 95.59 376.05 93.78 376.05C91.97 376.05 90.5 374.58 90.5 372.77C90.5 370.96 91.97 369.49 93.78 369.49C95.59 369.49 97.06 370.96 97.06 372.77Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.43,
    strokeMiterlimit: 5.71
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M106.66 338.01H65.8299C65.1782 338.01 64.6499 338.538 64.6499 339.19V363.46C64.6499 364.112 65.1782 364.64 65.8299 364.64H106.66C107.312 364.64 107.84 364.112 107.84 363.46V339.19C107.84 338.538 107.312 338.01 106.66 338.01Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M106.21 340.82H66.5699V362.42H106.21V340.82Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M109.77 326.17H102.37C101.718 326.17 101.19 326.698 101.19 327.35V329.72C101.19 330.372 101.718 330.9 102.37 330.9H109.77C110.422 330.9 110.95 330.372 110.95 329.72V327.35C110.95 326.698 110.422 326.17 109.77 326.17Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M108.28 264.64H103.85C102.541 264.64 101.48 265.701 101.48 267.01V270.11C101.48 271.419 102.541 272.48 103.85 272.48H108.28C109.589 272.48 110.65 271.419 110.65 270.11V267.01C110.65 265.701 109.589 264.64 108.28 264.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M101.48 268.04H74.26H101.48Z",
    fill: "#131F2E"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M101.48 268.04H74.26",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M98.23 253.84V281.65V253.84Z",
    fill: "#131F2E"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M98.23 253.84V281.65",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M94.38 256.28V279.36V256.28Z",
    fill: "#131F2E"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M94.38 256.28V279.36",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5 259.27V276.5V259.27Z",
    fill: "#131F2E"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5 259.27V276.5",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M86.73 262.86V274.21V262.86Z",
    fill: "#131F2E"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M86.73 262.86V274.21",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1799 265.23V270.81V265.23Z",
    fill: "#131F2E"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1799 265.23V270.81",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M79 266.41V269.81V266.41Z",
    fill: "#131F2E"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M79 266.41V269.81",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotaflex);
export default __webpack_public_path__ + "static/media/rotaflex.2963d78ffc20811627a2b7e4a0a3e046.svg";
export { ForwardRef as ReactComponent };